import 'bootstrap/dist/js/bootstrap.bundle'
// import '../assets/js/tiny-slider'
// import '../assets/js/custom'

import img1 from '../assets/images/sofa.png'
import img2 from '../assets/images/envelope-outline.svg'
import nemad from '../assets/images/enamad.png'
import { useGetSettingQuery } from '../../../Redux/Apis/siteApi';
import { NavLink } from 'react-router-dom';

function Footer() {
	const {data : { name,description, menu, contacts : { address,phone,mobile,email,socials } }} = useGetSettingQuery()

    return ( 
        <footer className="footer-section">
			<div className="container relative">

				<div className="sofa-img">
					<img src={img1} alt="" className="img-fluid"/>
				</div>

				<div className="row">
					<div className="col-lg-8">
						<div className="subscription-form">
							<h3 className="d-flex align-items-center">
								<span className="ms-1">
									<img src={img2} alt="" className="img-fluid"/>
								</span>
								<span>با ما در ارتباط باشید</span>
							</h3>

							<form action="#" className="row g-3">
								<div className="col-auto">
									<input type="text" className="form-control" placeholder="نام و نام خانوادگی"/>
								</div>
								<div className="col-auto">
									<input type="email" className="form-control" placeholder="شماره موبایل"/>
								</div>
								<div className="col-auto">
									<button className="btn btn-primary">
										<span className="fa fa-paper-plane"></span>
									</button>
								</div>
							</form>

						</div>
					</div>
				</div>

				<div className="row g-5 mb-5">
					<div className="col-lg-4">
						<div className="mb-4 footer-logo-wrap">
							<a href="!#" className="footer-logo">{name}<span>.</span></a>
						</div>
						<p className="mb-4">
							{description}
						</p>
						{socials && <ul className="list-unstyled custom-social px-0">
							{socials.map((row,index) =>
								{
									switch (row.key) {
										case 'فیسبوک':
											return <li key={index}><a href={row.value}><span className="fa fa-brands fa-facebook-f"></span></a></li>
										case 'توییتر':
											return <li key={index}><a href={row.value}><span className="fa fa-brands fa-twitter"></span></a></li>
										case 'اینستاگرام':
											return <li key={index}><a href={row.value}><span className="fa fa-brands fa-instagram"></span></a></li>
										case 'یوتیوب':
											return <li key={index}><a href={row.value}><span className="fa fa-brands fa-youtube"></span></a></li>
									
										default:
											return <></>
									}
								}
							)}
						</ul>}
					</div>

					<div className="col-lg-8">
						<div className="row links-wrap">
							

							<div className="col-6 col-sm-6 col-md-4">
								<h6>با ما در ارتباط باشید</h6>
								<ul className="list-unstyled pe-1">
									<li>آدرس: {address}</li>
									<li>ایمیل: <a href={`mailto:${email}`}>{email}</a></li>
									<li>تلفن: <a href={`tel:${phone}`}>{phone}</a></li>
									<li>موبایل: <a href={`tel:${mobile}`}>{mobile}</a></li>
								</ul>
							</div>

							<div className="col-6 col-sm-6 col-md-4">
								<h6>بخش های سایت</h6>
								<ul className="list-unstyled pe-1">
								{
									menu && menu.map((row,index) => 
										<li key={index}><NavLink to={row.value} end caseSensitive>{row.key}</NavLink></li>
									)
								}
								</ul>
							</div>

							<div className="col-6 col-sm-6 col-md-4">
								<h6>مجوز ها</h6>
								<img src={nemad} alt='nemad' className='img-fluid' width={200}></img>
							</div>
						</div>
					</div>

				</div>

				<div className="border-top copyright">
					<div className="row pt-4">
						<div className="col-lg-6">
							<p className="mb-2 text-lg-left">کپی رایت  &copy;2023، تمامی حقوق برای صاحب اثر محفوظ است. &mdash; توسعه با <span className="text-danger">&hearts;</span> در <a href="https://linket.me">لینکت</a>
            				</p>
						</div>

						{/* <div className="col-lg-6 text-start">
							<ul className="list-unstyled d-inline-flex ms-auto">
								<li className="ms-4"><a href="!#">قوانین و مقررات</a></li>
								<li><a href="!#">سوالات متداول</a></li>
							</ul>
						</div> */}

					</div>
				</div>

			</div>
		</footer>
    );
}

export default Footer;